// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}

.audit-page {
  background: #f3f4f8;
  display: grid;
  flex: 1 1 auto;
  gap: 0.55rem;
  grid-template-rows: auto auto minmax(0, 1fr);
  min-height: 0;
  overflow: hidden;
  padding: 0.65rem clamp(0.65rem, 2vw, 1.4rem) 0.75rem;
}

.page-heading {
  align-items: center;
  background: #fff;
  border: 1px solid #d9e2ec;
  border-left: 4px solid #007bff;
  border-radius: 7px;
  display: flex;
  height: auto !important;
  justify-content: space-between;
  margin: 0 !important;
  max-width: none !important;
  min-height: 58px !important;
  padding: 0.4rem 0.7rem;
  position: relative;
  width: auto !important;
}

.page-heading > div:first-child {
  flex: 1 1 auto;
  text-align: center;
}

.page-actions {
  display: flex;
  gap: 0.45rem;
  position: absolute;
  right: 0.7rem;
}

.page-actions button {
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.72rem;
  font-weight: 700;
  min-height: 34px;
  min-width: 86px;
  padding: 0.35rem 0.95rem;
}

.clean-all-button { background: #fff; border: 1px solid #aab5c3; color: #334b62; }
.clean-all-button:hover { border-color: #b4233f; color: #9b1c35; }
.print-button { background: #1f4e78; border: 1px solid #1f4e78; color: #fff; }
.print-button:hover { background: #173f63; }

.page-heading::before,
.page-heading::after {
  content: none !important;
  display: none !important;
}

h1 {
  color: #173a5e;
  font-size: clamp(1.15rem, 2vw, 1.55rem);
  font-weight: 700;
  line-height: 1.1;
  margin: 0;
}

.page-heading p {
  color: #66798b;
  font-size: 0.75rem;
  margin: 0.1rem 0 0;
}

.phase-badge {
  background: #e4f2fb;
  border: 1px solid #b8dcef;
  border-radius: 999px;
  color: #1f6086;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.28rem 0.65rem;
  position: absolute;
  right: 0.7rem;
}

.audit-tabs {
  background: #fff;
  border: 1px solid #d9dee7;
  border-radius: 7px;
  display: grid;
  grid-auto-columns: minmax(150px, 1fr);
  grid-auto-flow: column;
  overflow-x: auto;
  scrollbar-width: thin;
}

.audit-tabs button {
  align-items: center;
  background: #fff;
  border: 0;
  border-right: 1px solid #d9dee7;
  color: #53687b;
  cursor: pointer;
  display: flex;
  gap: 0.55rem;
  min-height: 48px;
  padding: 0.35rem 1rem;
  position: relative;
  text-align: left;
  white-space: nowrap;
}

.audit-tabs button:last-child {
  border-right: 0;
}

.audit-tabs button::after {
  background: transparent;
  bottom: 0;
  content: "";
  height: 3px;
  left: 0;
  position: absolute;
  right: 0;
}

.audit-tabs button.active {
  background: #f4f9fd;
  color: #153d61;
}

.audit-tabs button.active::after {
  background: #007bff;
}

.tab-number {
  align-items: center;
  background: #e7edf3;
  border-radius: 50%;
  display: flex;
  flex: 0 0 27px;
  font-size: 0.72rem;
  font-weight: 700;
  height: 27px;
  justify-content: center;
}

.active .tab-number {
  background: #007bff;
  color: #fff;
}

.audit-tabs button > span:last-child {
  display: grid;
}

.audit-tabs strong {
  font-size: 0.78rem;
}

.audit-tabs small {
  color: #7c8c9b;
  font-size: 0.65rem;
}

.tab-content {
  min-height: 0;
  overflow: hidden;
}

.tab-content > * {
  height: 100%;
}

.print-content { display: none; }

@media (max-width: 800px) {
  .audit-tabs small,
  .phase-badge {
    display: none;
  }

  .audit-tabs button {
    justify-content: center;
  }

  .page-heading > div:first-child { padding-right: 150px; }
}

@page {
  size: A4 landscape;
  margin: 8mm;
}

@media print {
  :host { display: block; height: auto; }
  .audit-page { background: #fff; display: block; overflow: visible; padding: 0; }
  .page-heading, .audit-tabs, .screen-content, app-confirm-clean-dialog { display: none !important; }
  .print-content { display: block; }
  .print-cover { border-bottom: 2px solid #1f4e78; margin-bottom: 6mm; padding: 0 0 3mm; }
  .print-cover h1 { font-size: 18pt; text-align: left; }
  .print-cover p { color: #53687b; font-size: 9pt; }
  .print-page { -moz-column-break-after: page; break-after: page; height: auto; min-height: 0; }
  .print-page:last-child { -moz-column-break-after: auto; break-after: auto; }

  ::ng-deep .print-page > *,
  ::ng-deep .print-page .questionnaire,
  ::ng-deep .print-page .equipment-sheet,
  ::ng-deep .print-page .information-layout,
  ::ng-deep .print-page .safety-layout,
  ::ng-deep .print-page .personnel-card {
    height: auto !important;
    min-height: 0 !important;
    overflow: visible !important;
  }

  ::ng-deep .print-page .questions,
  ::ng-deep .print-page .sheet-content,
  ::ng-deep .print-page .section-content,
  ::ng-deep .print-page .table-scroll {
    display: block !important;
    max-height: none !important;
    overflow: visible !important;
  }

  ::ng-deep .print-page .question-row,
  ::ng-deep .print-page .equipment-group,
  ::ng-deep .print-page tr { -moz-column-break-inside: avoid; break-inside: avoid; }
  ::ng-deep .print-page .clean-form-button,
  ::ng-deep .print-page .clean-section-button,
  ::ng-deep .print-page .section-switcher,
  ::ng-deep .print-page .add-person,
  ::ng-deep .print-page .remove-person,
  ::ng-deep .print-page app-confirm-clean-dialog { display: none !important; }
  ::ng-deep .print-page table { table-layout: fixed; width: 100%; }
  ::ng-deep .print-page input,
  ::ng-deep .print-page textarea,
  ::ng-deep .print-page select { color: #000; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  ::ng-deep .print-page textarea {
    field-sizing: content;
    height: auto !important;
    overflow: visible !important;
    resize: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/lab-audit-checklist/lab-audit-checklist.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,oBAAoB,gBAAgB,EAAE,yBAAyB,EAAE,cAAc,EAAE;AACjF,0BAA0B,qBAAqB,EAAE,cAAc,EAAE;AACjE,gBAAgB,mBAAmB,EAAE,yBAAyB,EAAE,WAAW,EAAE;AAC7E,sBAAsB,mBAAmB,EAAE;;AAE3C;;EAEE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,iBAAiB,aAAa,EAAE;;AAEhC;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA,kCAAkC,oBAAoB,EAAE;AAC1D;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,QAAQ,cAAc,EAAE,YAAY,EAAE;EACtC,cAAc,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE,UAAU,EAAE;EAC/E,wEAAwE,wBAAwB,EAAE;EAClG,iBAAiB,cAAc,EAAE;EACjC,eAAe,gCAAgC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;EACvF,kBAAkB,eAAe,EAAE,gBAAgB,EAAE;EACrD,iBAAiB,cAAc,EAAE,cAAc,EAAE;EACjD,cAAc,6BAAiB,EAAjB,iBAAiB,EAAE,YAAY,EAAE,aAAa,EAAE;EAC9D,yBAAyB,6BAAiB,EAAjB,iBAAiB,EAAE;;EAE5C;;;;;;IAME,uBAAuB;IACvB,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;;;;IAIE,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;;6BAE2B,+BAAmB,EAAnB,mBAAmB,EAAE;EAChD;;;;;mDAKiD,wBAAwB,EAAE;EAC3E,8BAA8B,mBAAmB,EAAE,WAAW,EAAE;EAChE;;iCAE+B,WAAW,EAAE,iCAAyB,EAAzB,yBAAyB,EAAE;EACvE;IACE,qBAAqB;IACrB,uBAAuB;IACvB,4BAA4B;IAC5B,uBAAuB;EACzB;AACF","sourcesContent":[":host {\n  display: flex;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.audit-page {\n  background: #f3f4f8;\n  display: grid;\n  flex: 1 1 auto;\n  gap: 0.55rem;\n  grid-template-rows: auto auto minmax(0, 1fr);\n  min-height: 0;\n  overflow: hidden;\n  padding: 0.65rem clamp(0.65rem, 2vw, 1.4rem) 0.75rem;\n}\n\n.page-heading {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #d9e2ec;\n  border-left: 4px solid #007bff;\n  border-radius: 7px;\n  display: flex;\n  height: auto !important;\n  justify-content: space-between;\n  margin: 0 !important;\n  max-width: none !important;\n  min-height: 58px !important;\n  padding: 0.4rem 0.7rem;\n  position: relative;\n  width: auto !important;\n}\n\n.page-heading > div:first-child {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.page-actions {\n  display: flex;\n  gap: 0.45rem;\n  position: absolute;\n  right: 0.7rem;\n}\n\n.page-actions button {\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.72rem;\n  font-weight: 700;\n  min-height: 34px;\n  min-width: 86px;\n  padding: 0.35rem 0.95rem;\n}\n\n.clean-all-button { background: #fff; border: 1px solid #aab5c3; color: #334b62; }\n.clean-all-button:hover { border-color: #b4233f; color: #9b1c35; }\n.print-button { background: #1f4e78; border: 1px solid #1f4e78; color: #fff; }\n.print-button:hover { background: #173f63; }\n\n.page-heading::before,\n.page-heading::after {\n  content: none !important;\n  display: none !important;\n}\n\nh1 {\n  color: #173a5e;\n  font-size: clamp(1.15rem, 2vw, 1.55rem);\n  font-weight: 700;\n  line-height: 1.1;\n  margin: 0;\n}\n\n.page-heading p {\n  color: #66798b;\n  font-size: 0.75rem;\n  margin: 0.1rem 0 0;\n}\n\n.phase-badge {\n  background: #e4f2fb;\n  border: 1px solid #b8dcef;\n  border-radius: 999px;\n  color: #1f6086;\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 0.28rem 0.65rem;\n  position: absolute;\n  right: 0.7rem;\n}\n\n.audit-tabs {\n  background: #fff;\n  border: 1px solid #d9dee7;\n  border-radius: 7px;\n  display: grid;\n  grid-auto-columns: minmax(150px, 1fr);\n  grid-auto-flow: column;\n  overflow-x: auto;\n  scrollbar-width: thin;\n}\n\n.audit-tabs button {\n  align-items: center;\n  background: #fff;\n  border: 0;\n  border-right: 1px solid #d9dee7;\n  color: #53687b;\n  cursor: pointer;\n  display: flex;\n  gap: 0.55rem;\n  min-height: 48px;\n  padding: 0.35rem 1rem;\n  position: relative;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.audit-tabs button:last-child {\n  border-right: 0;\n}\n\n.audit-tabs button::after {\n  background: transparent;\n  bottom: 0;\n  content: \"\";\n  height: 3px;\n  left: 0;\n  position: absolute;\n  right: 0;\n}\n\n.audit-tabs button.active {\n  background: #f4f9fd;\n  color: #153d61;\n}\n\n.audit-tabs button.active::after {\n  background: #007bff;\n}\n\n.tab-number {\n  align-items: center;\n  background: #e7edf3;\n  border-radius: 50%;\n  display: flex;\n  flex: 0 0 27px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  height: 27px;\n  justify-content: center;\n}\n\n.active .tab-number {\n  background: #007bff;\n  color: #fff;\n}\n\n.audit-tabs button > span:last-child {\n  display: grid;\n}\n\n.audit-tabs strong {\n  font-size: 0.78rem;\n}\n\n.audit-tabs small {\n  color: #7c8c9b;\n  font-size: 0.65rem;\n}\n\n.tab-content {\n  min-height: 0;\n  overflow: hidden;\n}\n\n.tab-content > * {\n  height: 100%;\n}\n\n.print-content { display: none; }\n\n@media (max-width: 800px) {\n  .audit-tabs small,\n  .phase-badge {\n    display: none;\n  }\n\n  .audit-tabs button {\n    justify-content: center;\n  }\n\n  .page-heading > div:first-child { padding-right: 150px; }\n}\n\n@page {\n  size: A4 landscape;\n  margin: 8mm;\n}\n\n@media print {\n  :host { display: block; height: auto; }\n  .audit-page { background: #fff; display: block; overflow: visible; padding: 0; }\n  .page-heading, .audit-tabs, .screen-content, app-confirm-clean-dialog { display: none !important; }\n  .print-content { display: block; }\n  .print-cover { border-bottom: 2px solid #1f4e78; margin-bottom: 6mm; padding: 0 0 3mm; }\n  .print-cover h1 { font-size: 18pt; text-align: left; }\n  .print-cover p { color: #53687b; font-size: 9pt; }\n  .print-page { break-after: page; height: auto; min-height: 0; }\n  .print-page:last-child { break-after: auto; }\n\n  ::ng-deep .print-page > *,\n  ::ng-deep .print-page .questionnaire,\n  ::ng-deep .print-page .equipment-sheet,\n  ::ng-deep .print-page .information-layout,\n  ::ng-deep .print-page .safety-layout,\n  ::ng-deep .print-page .personnel-card {\n    height: auto !important;\n    min-height: 0 !important;\n    overflow: visible !important;\n  }\n\n  ::ng-deep .print-page .questions,\n  ::ng-deep .print-page .sheet-content,\n  ::ng-deep .print-page .section-content,\n  ::ng-deep .print-page .table-scroll {\n    display: block !important;\n    max-height: none !important;\n    overflow: visible !important;\n  }\n\n  ::ng-deep .print-page .question-row,\n  ::ng-deep .print-page .equipment-group,\n  ::ng-deep .print-page tr { break-inside: avoid; }\n  ::ng-deep .print-page .clean-form-button,\n  ::ng-deep .print-page .clean-section-button,\n  ::ng-deep .print-page .section-switcher,\n  ::ng-deep .print-page .add-person,\n  ::ng-deep .print-page .remove-person,\n  ::ng-deep .print-page app-confirm-clean-dialog { display: none !important; }\n  ::ng-deep .print-page table { table-layout: fixed; width: 100%; }\n  ::ng-deep .print-page input,\n  ::ng-deep .print-page textarea,\n  ::ng-deep .print-page select { color: #000; print-color-adjust: exact; }\n  ::ng-deep .print-page textarea {\n    field-sizing: content;\n    height: auto !important;\n    overflow: visible !important;\n    resize: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
